import { view } from '@yola/ws-sdk';
import getUniqueValues from 'src/js/modules/utils/get-unique-values';

const getOptionTargetElementIdsByQuerySelector = (elementId, querySelector) => {
  const liveElement = view.accessors.getLiveElement(elementId);
  const elements = liveElement.matches(querySelector)
    ? [liveElement]
    : liveElement.querySelectorAll(querySelector);

  return [...elements].map((el) => view.accessors.getLiveElementId(el));
};

const getOptionTargetElementIds = (elementId, option) => {
  if (option.querySelector) {
    return getOptionTargetElementIdsByQuerySelector(elementId, option.querySelector);
  }

  if (option.options) {
    return getUniqueValues(
      option.options.flatMap((subOption) => getOptionTargetElementIds(elementId, subOption))
    );
  }

  return [elementId];
};

export default getOptionTargetElementIds;
